var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.084,
    height: 25.791,
    viewBox: "0 0 21.084 25.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications-outline",
    d: "M98.632,65.353c-1.387-1.8-2.367-2.713-2.367-7.668,0-4.538-2.189-6.155-3.991-6.94a1,1,0,0,1-.538-.6,2.392,2.392,0,0,0-4.757,0,.987.987,0,0,1-.538.6c-1.8.786-3.991,2.4-3.991,6.94,0,4.956-.982,5.871-2.37,7.668a1.156,1.156,0,0,0,.934,1.863H97.7A1.157,1.157,0,0,0,98.632,65.353Zm-5.818,1.863v.915a3.463,3.463,0,1,1-6.916,0v-.915",
    transform: "translate(-78.814 -47)",
    fill: "none",
    stroke: "#00adc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.50c2bccffcc5ec3fcba4055a784c119c.svg";
export { ForwardRef as ReactComponent };